/* eslint-disable no-undef */
/* eslint-disable no-undef */
<template>
  <div class="list">
    <template v-for="(item, index) in model">
      <div
        :class="['item',item.level?'a'+item.level.toString():'',isBian]   "
        :key="'key-' + index"
      >
        <div class="menu-content">
          <p @click="scrollTo(item.id)">{{item.title}}
            <span>{{item.content}}</span>
          </p>
        </div>
      </div>
      <menu-tree
        @scrollTo="scrollTo"
        v-show="open"
        :bian="bian"
        :key="'key1-' + index"
        :model="item.items"
      >
      </menu-tree>
    </template>
  </div>
</template>

<script>
$(function () {
  $(' .down').click(function (e) {
    console.log($(this))
  })
})
export default {
  name: 'menuTree',
  props: {
    model: Array,
    bian: Boolean
  },
  data () {
    return {
      open: true
    }
  },
  computed: {
    isBian () {
      if (this.bian) {
        return 'bian'
      }
      return ''
    }
  },
  methods: {
    toggle () { // 点击展开下一级
      if (this.isFolder) {
        this.open = !this.open
      }
    },
    isFolder (item) { // 是否有下一级
      return item.items &&
        item.items.length
    },
    scrollTo (id) {
      this.$emit('scrollTo', id)
    }
  }
}
</script>
<style lang="stylus" scoped>
.list
  list-style none
  flex 1
  padding 0 0 1.5rem 0
  .list
    overflow-y auto
    margin 0
    flex none
    padding 0
  .item
    padding 0.15rem
    font-size 0.28rem
    border-bottom 1px solid rgba(255, 255, 255, 0.2)
    box-sizing border-box
    padding 0.2rem 0
    padding-right 0.3rem
    &.a1
      font-size 0.28rem
      font-weight 700
      padding-left 0.12rem
    &.a2
      font-size 0.24rem
      font-weight 550
      padding-left 0.3rem
    &.a3
      font-size 0.2rem
      margin-left 0.6rem
    .menu-content
      display flex
      justify-content space-between
    .right
      width 0.16rem
      height 0.3rem
      opacity 0.5
    .down
      width 0.3rem
      height 0.16rem
  p
    margin 0
    flex 1
    span
      margin-left 0.2rem
      line-height 1.6
</style>
